









































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { mapState } from "vuex";
import RequestPromises from "@/mixins/requestPromises";
import i18n from "@/i18n";
import { ITemplate } from "@/models/templates";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { TemplateTypes } from "@/data/enums/templates";

@Component({
  computed: {
    ...mapState({
      templates(state, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.TEMPLATES
        });
      }
    })
  }
})
export default class SendEmailDropDown extends Mixins(RequestPromises) {
  // Props
  @Prop({ required: true })
  public type!: string;

  @Prop({ required: true })
  public objectId!: string;

  @Prop({ default: () => i18n.t("_action.send_email") })
  public title!: string;

  @Prop({ default: NotificationChannelCodes.EMAIL })
  public channelCode!: NotificationChannelCodes;

  @Prop({ default: true })
  public includeDefault!: boolean;

  @Prop({ default: true })
  public includeCustom!: boolean;

  // Data
  public templates!: ITemplate[];
  public isLoading = false;
  public isProcessing = false;
  public selectedTemplate?: ITemplate | null = null;

  // Lifecycle Methods
  public created() {
    this.getTemplates().then(() => {
      if (this.$_.has(this.$refs, "select")) {
        (this.$refs.select as HTMLElement).focus();
      }
    });
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.TEMPLATES,
      vm: this
    });
  }

  // Getters
  public get defaultTemplates() {
    return this.$_.orderBy(
      this.$_.filter(this.templates, i => i.default),
      ["name"],
      ["asc"]
    );
  }

  public get customTemplates() {
    return this.$_.orderBy(
      this.$_.filter(this.templates, i => !i.default),
      ["name"],
      ["asc"]
    );
  }

  public get getFilterForType() {
    return this.type ? { "filter[category.code]": this.type } : {};
  }

  public get getFilterForDefault() {
    if (this.includeDefault && !this.includeCustom)
      return { "filter[default]": 1 };
    else if (!this.includeDefault && this.includeCustom)
      return { "filter[default]": 0 };
    else return {};
  }

  public get getFilterForChannel() {
    return this.type ? { "filter[channel.code]": this.channelCode } : {};
  }

  // Methods
  public getTemplates(payload = {}) {
    this.isLoading = true;
    return this.$store
      .dispatch(`data/${DataModules.TEMPLATES}/list`, {
        vm: this,
        params: {
          limit: 0,
          with: "category,channel",
          ...this.getFilterForType,
          ...this.getFilterForChannel,
          ...this.getFilterForDefault
        },
        ...payload
      })
      .finally(() => (this.isLoading = false));
  }

  public sendEmail(template) {
    if (!this.selectedTemplate) return;
    this.isProcessing = true;
    this.$store
      .dispatch(`data/${DataModules.TEMPLATES}/send`, {
        id: template.id,
        data: {
          object_id: this.objectId
        },
        vm: this
      })
      .then(() => {
        this.$set(this, "selectedTemplate", null);
        this.$store.dispatch("toast/show", {
          message: this.$t("_sentence.successfully_sent")
        });
        this.$emit("close");
      })
      .catch(error => {
        // Template has been deleted
        const is404 = this.$store.getters["api/is404"](error);
        if (is404) {
          this.getTemplates({ ignoreStored: true });
          this.selectedTemplate = null;
        }

        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  public onTemplateChange(value) {
    if (value !== "new") return;
    this.openAddTemplateModal();
  }

  async openAddTemplateModal() {
    const modal = await this.$store.dispatch(
      `data/${DataModules.TEMPLATES}/openAddEditModal`,
      {
        props: {
          templateType: TemplateTypes.NOTIFICATION,
          showSubmitButton: false,
          showHookSelector: false,
          showChannelSelector: false,
          showActiveToggle: false,
          preselectedCategoryCode: this.type,
          preselectedChannelCode: NotificationChannelCodes.EMAIL
        },
        onCancel: () => {
          this.selectedTemplate = null;
        },
        events: {
          success: async template => {
            await this.getTemplates({ ignoreStored: true });
            this.selectedTemplate = this.customTemplates.find(
              i => i.id === template.id
            );
            modal.close();
          }
        }
      }
    );
  }
}
